"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortRatesByCheapest = void 0;
const getNumberOfVehicles_1 = require("./getNumberOfVehicles");
const sortRatesByCheapest = (rates, type, number_of_passengers) => {
    //sort the rates by passenger count
    const available_rates = [];
    let error_type = "NO_RATES";
    // if custom then we need to care about both inbound and outbound
    if (type === "CUSTOM") {
        const sortedOutboundRates = rates?.outbound?.sort((a, b) => {
            return a.max_pax - b.max_pax;
        });
        if (!sortedOutboundRates) {
            return null;
        }
        const groupedOutboundRates = sortedOutboundRates.reduce((acc, rate) => {
            const vehicle = acc.find((v) => v.vehicle_id === rate.vehicle_id);
            if (vehicle) {
                vehicle.rates.push(rate);
            }
            else {
                acc.push({
                    vehicle_id: rate.vehicle_id,
                    vehicle_name: rate.vehicle_name,
                    vehicle_image: rate.vehicle_image,
                    vehicle_max_pax: rate.max_pax,
                    rates: [rate],
                });
            }
            return acc;
        }, []);
        const sortedInboundRates = rates?.inbound?.sort((a, b) => {
            return a.max_pax - b.max_pax;
        });
        if (!sortedInboundRates) {
            return null;
        }
        const groupedInboundRates = sortedInboundRates.reduce((acc, rate) => {
            const vehicle = acc.find((v) => v.vehicle_id === rate.vehicle_id);
            if (vehicle) {
                vehicle.rates.push(rate);
            }
            else {
                acc.push({
                    vehicle_id: rate.vehicle_id,
                    vehicle_name: rate.vehicle_name,
                    vehicle_image: rate.vehicle_image,
                    vehicle_max_pax: rate.max_pax,
                    rates: [rate],
                });
            }
            return acc;
        }, []);
        // across groupedOutboundRates and groupedInboundRates filter out any row that doesn't have a vehicle_id that is in both
        const outboundVehicleIds = groupedOutboundRates.map((v) => v.vehicle_id);
        const inboundVehicleIds = groupedInboundRates.map((v) => v.vehicle_id);
        const commonVehicleIds = outboundVehicleIds.filter((v) => inboundVehicleIds.includes(v));
        const filteredOutboundRates = groupedOutboundRates.filter((v) => commonVehicleIds.includes(v.vehicle_id));
        const filteredInboundRates = groupedInboundRates.filter((v) => commonVehicleIds.includes(v.vehicle_id));
        // loop through the outbound rates and find the inbound rate that matches the vehicle_id
        filteredOutboundRates.forEach((outboundRate) => {
            const inboundRate = filteredInboundRates.find((v) => v.vehicle_id === outboundRate.vehicle_id);
            const cheapestOutboundRate = outboundRate.rates[0];
            const cheapestInboundRate = inboundRate.rates[0];
            const maxPax = Math.min(cheapestOutboundRate.max_pax, cheapestInboundRate.max_pax);
            if (cheapestOutboundRate.supplier_name !== cheapestInboundRate.supplier_name) {
                error_type = "DIFFERENT_SUPPLIERS";
                return;
            }
            const rate_obj = {
                vehicle: {
                    id: cheapestOutboundRate.vehicle_id,
                    name: cheapestOutboundRate.vehicle_name,
                    image: cheapestOutboundRate.vehicle_image,
                    description: cheapestOutboundRate.vehicle_description,
                },
                rates: {
                    type: "CONTRACT",
                    inbound: cheapestInboundRate.rate_id,
                    outbound: cheapestOutboundRate.rate_id,
                },
                supplier: {
                    id: cheapestOutboundRate.supplier_id,
                    name: cheapestOutboundRate.supplier_name,
                },
                rate_base_currency: cheapestOutboundRate.base_currency,
                rate_max_pax: maxPax,
                rate_number_of_vehicles: (0, getNumberOfVehicles_1.getNumberOfVehicles)(maxPax, number_of_passengers),
                rate_outbound_total_price: cheapestOutboundRate.single_sell_price *
                    (0, getNumberOfVehicles_1.getNumberOfVehicles)(maxPax, number_of_passengers),
                rate_inbound_total_price: cheapestInboundRate.single_sell_price *
                    (0, getNumberOfVehicles_1.getNumberOfVehicles)(maxPax, number_of_passengers),
                rate_total_price: (cheapestOutboundRate.single_sell_price +
                    cheapestInboundRate.single_sell_price) *
                    (0, getNumberOfVehicles_1.getNumberOfVehicles)(maxPax, number_of_passengers),
                rate_outbound_sell_price: cheapestOutboundRate.single_sell_price,
                rate_inbound_sell_price: cheapestInboundRate.single_sell_price,
                rate_sell_price: cheapestOutboundRate.single_sell_price +
                    cheapestInboundRate.single_sell_price,
                rate_outbound_cost_price: cheapestOutboundRate.single_cost_price,
                rate_inbound_cost_price: cheapestInboundRate.single_cost_price,
                rate_cost_price: cheapestOutboundRate.single_cost_price +
                    cheapestInboundRate.single_cost_price,
                rate_outbound_margin: cheapestOutboundRate.single_markup,
                rate_inbound_margin: cheapestInboundRate.single_markup,
                rate_margin: cheapestOutboundRate.single_markup +
                    cheapestInboundRate.single_markup,
            };
            available_rates.push(rate_obj);
        });
    }
    // its a single or return therefore we only care about the outbound routes
    else {
        const sortedRates = rates?.outbound?.sort((a, b) => {
            return a.max_pax - b.max_pax;
        });
        if (!sortedRates) {
            return null;
        }
        const groupedRates = sortedRates.reduce((acc, rate) => {
            const vehicle = acc.find((v) => v.vehicle_id === rate.vehicle_id);
            if (vehicle) {
                vehicle.rates.push(rate);
            }
            else {
                acc.push({
                    vehicle_id: rate.vehicle_id,
                    vehicle_name: rate.vehicle_name,
                    vehicle_description: rate.vehicle_description,
                    vehicle_image: rate.vehicle_image,
                    vehicle_max_pax: rate.max_pax,
                    rates: [rate],
                });
            }
            return acc;
        }, []);
        // loop through each grouped rate and pick the cheapest one
        groupedRates.forEach((group) => {
            const cheapestRate = group.rates[0];
            const rate_obj = {
                vehicle: {
                    id: group.vehicle_id,
                    name: group.vehicle_name,
                    image: group.vehicle_image,
                    description: group.vehicle_description,
                },
                rates: {
                    type: "CONTRACT",
                    outbound: cheapestRate.rate_id,
                    inbound: type === "RETURN" ? cheapestRate.rate_id : null,
                },
                supplier: {
                    id: cheapestRate.supplier_id,
                    name: cheapestRate.supplier_name,
                    offerings: cheapestRate.supplier_offerings,
                },
                rate_base_currency: cheapestRate.base_currency,
                rate_max_pax: cheapestRate.max_pax,
                rate_number_of_vehicles: (0, getNumberOfVehicles_1.getNumberOfVehicles)(cheapestRate.max_pax, number_of_passengers),
                rate_total_price: (type === "ONE_WAY"
                    ? cheapestRate.single_sell_price
                    : cheapestRate.return_sell_price) *
                    (0, getNumberOfVehicles_1.getNumberOfVehicles)(cheapestRate.max_pax, number_of_passengers),
                rate_sell_price: type === "ONE_WAY"
                    ? cheapestRate.single_sell_price
                    : cheapestRate.return_sell_price,
                rate_cost_price: type === "ONE_WAY"
                    ? cheapestRate.single_cost_price
                    : cheapestRate.return_cost_price,
                rate_margin: type === "ONE_WAY"
                    ? cheapestRate.single_markup
                    : cheapestRate.return_markup,
            };
            available_rates.push(rate_obj);
        });
    }
    if (available_rates.length === 0) {
        return {
            type: error_type,
            rates: [],
        };
    }
    else {
        return {
            type: "RATES_FOUND",
            rates: available_rates.sort((a, b) => {
                return a.rate_total_price - b.rate_total_price;
            }),
        };
    }
};
exports.sortRatesByCheapest = sortRatesByCheapest;
